import { useState } from 'react';

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  function toggle() {
    setIsShowing(!isShowing);
  }

  function hide() {
    setIsShowing(false);
  }

  return {
    isShowing,
    toggle,
    hide,
  };
};

export default useModal;
